import { render } from "./PageAbout.vue?vue&type=template&id=4c456886"
import script from "./PageAbout.vue?vue&type=script&lang=js"
export * from "./PageAbout.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__